import { render, staticRenderFns } from "./kc.vue?vue&type=template&id=47d11e92&scoped=true&"
import script from "./kc.vue?vue&type=script&lang=js&"
export * from "./kc.vue?vue&type=script&lang=js&"
import style0 from "./kc.vue?vue&type=style&index=0&id=47d11e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d11e92",
  null
  
)

export default component.exports